import { TpCountDownData } from '../../components/message-boxes/CountDownbox';
import { taskExecutionPollingId } from '../../data/pollingService';
import { PollingConfiguration } from '../../data/pollingSlice';

export const countDownDataApp: TpCountDownData = {
  title: 'Session Timeout',
  description: 'Your session will time out soon. Do you want to stay logged in?',
  okButtonLabel: 'Stay Logged In',
  cancelButtonLabel: 'Log Out',
  timer: 30,
};

export const pollingConfigApp: PollingConfiguration = {
  identifier: taskExecutionPollingId,
  interval: 20000,
};
